<template>
  <div id="SectionAvoidPitfalls">
    <UIContainer>
      <template #left>
        <SectionTitle>
          <template #title>
            <span class="SectionAvoidPitfalls__title">
              Over 30% of SBTi Submissions Require Revisions. Avoid the
              Pitfalls.
            </span>
          </template>
          <template #description>
            <span class="SectionAvoidPitfalls__description">
              We combine deep technical expertise with proven methodologies to
              guide your organization through every step of the SBTi validation
              process. Our comprehensive approach ensures your targets are not
              only approved but also actionable and aligned with your business
              strategy.
            </span>
          </template>
        </SectionTitle>

        <div class="SectionAvoidPitfalls__cost">
          <div class="SectionAvoidPitfalls__cost-icon-container">
            <UIIcon
              class="SectionAvoidPitfalls__cost-icon"
              name="alertCircle"
            />
          </div>

          <div class="SectionAvoidPitfalls__cost-content">
            <h3 class="SectionAvoidPitfalls__cost-title">
              The cost of inaction
            </h3>

            <p class="SectionAvoidPitfalls__cost-description">
              Submissions that require major revisions
              <strong>spend 2x more on consulting</strong> and internal
              resources, face an average <strong>6-month delay</strong>
              in target approval, and risk a significant loss of credibility
              with key investors and customers.
            </p>
          </div>
        </div>
      </template>

      <template #right>
        <img
          class="SectionAvoidPitfalls__image"
          src="../assets/avoidPitfalls/bg.avif"
          alt="Manufacturing compliance challenges"
          loading="lazy"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
</script>

<style lang="scss" scoped>
#SectionAvoidPitfalls {
  background-color: $color-white;
  .SectionAvoidPitfalls__title {
    @include font-size-18px();
    @include md {
      @include font-size-30px;
    }
  }
  .SectionAvoidPitfalls__description {
    @include font-size-16px();
    color: $color-ui-gray-cool-600;
    @include md {
      @include font-size-18px;
    }
  }

  .SectionAvoidPitfalls__cost {
    display: flex;
    border-left: 3px solid $color-ui-warning-300;
    max-width: 31.25rem;
    width: 100%;
    margin-top: 1.5rem;

    @include md {
      margin-top: 3rem;
    }
  }

  .SectionAvoidPitfalls__cost-icon-container {
    margin: 0.25rem 0.5rem 0 1rem;
  }

  .SectionAvoidPitfalls__cost-icon {
    --size: 1.25rem;
    --color: #{$color-ui-warning-400};
  }

  .SectionAvoidPitfalls__cost-title {
    @include font-size-16px;
    margin-bottom: 0.25rem;
    color: $color-ui-warning-600;
    font-weight: 600;

    @include md {
      @include font-size-20px;
    }
  }

  .SectionAvoidPitfalls__cost-description {
    @include font-size-14px;
    color: $color-ui-gray-cool-700;

    @include md {
      @include font-size-16px;
    }
  }

  .SectionAvoidPitfalls__image {
    width: 100%;
    display: none;
    padding-left: 0rem;

    @include md {
      display: block;
      padding-left: 2rem;
    }
  }
}
</style>
